import React from 'react';
import { connect } from 'dva';

import { Tooltip } from 'antd';
import { getUserById } from 'selectors';

import styles from './index.less';

class UserDisplay extends React.Component {
  render() {
    const { user, userId, dispatch, ...rest } = this.props;
    if (!user) return (<span className={styles.user} {...rest}>{userId}</span>);

    const identity = user.identities && user.identities.find(i => i.type === 'email');
    const email = identity ? identity.id : '';
    return (
      <span className={styles.user} {...rest}><Tooltip trigger="click" title={email}> {user.displayName}</Tooltip></span>
    );
  }
}

export default connect((state, ownProps) => ({
  user: getUserById(state, ownProps.userId),
}))(UserDisplay);



// WEBPACK FOOTER //
// ./src/components/User/Display.js